import { rem } from 'polished';
import styled from 'styled-components';
import Image from '@legacy-vfuk/core-image';

export const TPTooltipTitle = styled.p`
  font-size: ${rem('20px')} !important;
  color: #a13d25;
  margin: 0;
  font-weight: 400;
  z-index: 3;
  text-align: center;
`;

export const TPTooltipProductName = styled.p`
  font-size: ${rem('30px')} !important;
  color: #666666;
  margin: 0;
  font-weight: 700;
`;

export const TPTooltipSubtitle = styled.p`
  font-size: ${rem('18px')} !important;
  font-weight: 400;
  color: #333333;
  margin: 0 0 ${rem('4px')} 0;
`;

export const TPTooltipDescription = styled.p`
  font-size: ${rem('16px')} !important;
  color: #333333;
  margin: 0;
`;

export const TPTooltipSubDescription = styled.p`
  font-size: ${rem('12px')} !important;
  color: #333333;
  font-weight: 400;
  margin: 0 0 ${rem('4px')} 0;
`;
